import { activateCard } from '@/_redesign/modules/Card/modules/ActicateCard/locale';
import { cardIssue } from '@/_redesign/modules/Card/modules/CardIssue/locale';
import { changePin } from '@/_redesign/modules/Card/modules/ChangePin/locale';

import enCard from './i18n.card.json';

export const card = {
  en: {
    ...enCard,
    ...changePin.en,
    ...cardIssue.en,
    ...activateCard.en,
  },
};
